import '/home/runner/work/gh-dashboard-relay/gh-dashboard-relay/node_modules/@chakra-ui/storybook-addon/dist/manager.mjs';